// 9fbef606107a605d69c0edbcd8029e5d 
const EMAIL_SIGNUP_CONSTANTS = {
  SMS_SUBSCRIPTION_MODAL_TOGGLE: 'SMS_SUBSCRIPTION_MODAL_TOGGLE',
};

export default EMAIL_SIGNUP_CONSTANTS;
